<template>
  <div id="app">
    <Layout>
      <router-view></router-view>
    </Layout>
  </div>
</template>

<script>

import Layout from './components/Layout';

export default {
  name: 'App',
  components: {
    Layout,
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 32px;
  height: calc(100vh - 92px);
}
h1 {
  padding: 16px;
}
button {
  margin: 8px;
}
.content {
  height: calc(100%);
}
a {
  color: #598ED9;
}
</style>
